import React, { useEffect } from "react";
import HolderContainer from "../../components/Reusable/HolderContainer";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import NotificationListItem from "./NotificationListItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageNotificationList } from "../../actions/blog";
import { t } from "i18next"; // Import t function for translation
import InfoBox from "../../components/Reusable/InfoBox";

const Notification = () => {
  const dispatch = useDispatch();

  const { notificationList } = useSelector((state) => state.blogReducer);

  useEffect(() => {
    dispatch(fetchPageNotificationList(1000));
  }, [dispatch]);

  return (
    <div className="notification-main-container">
      <Breadcrumb title={t("header.notifications")} returnPage="/" />

      <div className="notification-list-container">
        {notificationList?.content?.length === 0 ? (
          <InfoBox text={t("header.notificationsEmpty")} />
        ) : (
          notificationList?.content?.map((notification) => (
            <NotificationListItem item={notification} />
          ))
        )}
      </div>
    </div>
  );
};

export default Notification;
